export enum Notifications {
    email = 'E',
    sms = 'S',
    emailOrSms = 'E',
    link = 'L',
    checkin = 'N'
}
